import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type WhatsappLiveChatModuleSpecsFragment } from '../../../../api/fragments/WhatsappLiveChatModuleSpecs';
import WhatsappLiveChatSettingActions from './WhatsappLiveChatSettingActions';

export type WhatsappLiveChatSettingsTableProps = {
    module: WhatsappLiveChatModuleSpecsFragment;
};

export type ItemSpecs = WhatsappLiveChatModuleSpecsFragment['liveChatSettings'][number];

const WhatsappLiveChatSettingsTable = ({ module }: WhatsappLiveChatSettingsTableProps) => {
    const { t } = useTranslation(['whatsappLiveChatModuleDetails']);

    const renderActions = useCallback(
        (record: ItemSpecs) => <WhatsappLiveChatSettingActions module={module} settings={record} />,
        [module]
    );

    return (
        <Table dataSource={module.liveChatSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('whatsappLiveChatModuleDetails:settingsTable.columns.displayName')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('whatsappLiveChatModuleDetails:settingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default WhatsappLiveChatSettingsTable;
